import { MutableRefObject } from 'react';
import { CameraControls } from '@react-three/drei';
import * as THREE from 'three';

const normalize = (v: THREE.Vector3): THREE.Vector3 => {
  const length = v.length();
  return new THREE.Vector3(v.x / length, v.y / length, v.z / length);
};

const multiplyMatrixAndVector = (matrix: number[][], vector: THREE.Vector3) => {
  return {
    x: matrix[0][0] * vector.x + matrix[0][1] * vector.y + matrix[0][2] * vector.z,
    y: matrix[1][0] * vector.x + matrix[1][1] * vector.y + matrix[1][2] * vector.z,
    z: matrix[2][0] * vector.x + matrix[2][1] * vector.y + matrix[2][2] * vector.z,
  };
}

const rotationMatrixAroundAxis = (axis: THREE.Vector3, angle: number) => {
  const cos = Math.cos(angle);
  const sin = Math.sin(angle);
  const { x, y, z } = axis;
  return [
    [
      cos + x * x * (1 - cos),
      x * y * (1 - cos) - z * sin,
      x * z * (1 - cos) + y * sin,
    ],
    [
      y * x * (1 - cos) + z * sin,
      cos + y * y * (1 - cos),
      y * z * (1 - cos) - x * sin,
    ],
    [
      z * x * (1 - cos) - y * sin,
      z * y * (1 - cos) + x * sin,
      cos + z * z * (1 - cos),
    ],
  ];
}

const rotateVectorAroundAxis = (vector: THREE.Vector3, axis: THREE.Vector3, angle: number) => {
  const normalizedAxis = normalize(axis);
  const rotationMatrix = rotationMatrixAroundAxis(normalizedAxis, angle);
  return multiplyMatrixAndVector(rotationMatrix, vector);
}

export const rotationClick = (
  cameraRef: MutableRefObject<CameraControls>,
  CW: boolean
) => {
  if (!cameraRef.current) return;

  const lookAt = new THREE.Vector3();
  const position = new THREE.Vector3();
  cameraRef.current.getTarget(lookAt, true);
  cameraRef.current.getPosition(position, true);

  const AB = new THREE.Vector3().subVectors(lookAt, position);

  const cameraUp = cameraRef.current.camera.up;
  const rotatedCameraUp = rotateVectorAroundAxis(cameraUp, AB, CW ? Math.PI / 2 : -Math.PI / 2);
  cameraRef.current.camera.up.set(rotatedCameraUp.x, rotatedCameraUp.y, rotatedCameraUp.z);
}
